import { gql } from '@/__generated__/gql';

export const INVESTOR_DETAILS_PAGE_DETAILS_SECTION_LEGAL_ENTITY_QUERY = gql(`
  query InvestorDetailsPageDetailsSectionLegalEntity($id: String!, $includingProposed: Boolean) {
    legalEntity(id: $id, includingProposed: $includingProposed) {
      id
      alwaysShow
      targetAllocation
      currentAllocation
      unfundedCommitment
      totalEntityValue
      privatePercentage
      targetOCRatio
      currentOCRatio
      defaultBiteSize1
      defaultBiteSize2
      sectorsToAvoid
      entityType
      otherType
      taxStatus
      pacingProgressBarValues {
        currentQuarterEnd
        totalCommitments
        planGoal
        totalGoal
        isGoalAchieved
      }
      progressBarValues {
        economicExposure
        totalCapitalTarget
        capitalTarget
        isGoalAchieved
      }
    }
  }
`);

export const INVESTOR_DETAILS_PAGE_DETAILS_SECTION_GROUP_BY_PRIMARY_ENTITY_ID_QUERY = gql(`
  query InvestorDetailsPageDetailsSectionGroupByPrimaryEntityId($data: GetGroupInput!) {
    group(data: $data) {
      id
      alwaysShow
      targetAllocation
      currentAllocation
      totalEntityValue
      privatePercentage
      targetOCRatio
      currentOCRatio
      defaultBiteSize1
      defaultBiteSize2
      sectorsToAvoid
      entityType
      entities {
        id
        taxExempt
        taxStatus
      }
      pacingProgressBarValues {
        currentQuarterEnd
        totalCommitments
        planGoal
        totalGoal
        isGoalAchieved
      }
      progressBarValues {
        economicExposure
        totalCapitalTarget
        capitalTarget
        isGoalAchieved
      }
    }
  }
`);
